// Copyright (c) 2016 Deere & Company

import JdpClaimContainer from '../../claim/marketing/jdp/state-connector';

export default {
    component: JdpClaimContainer,
    name: 'MARKETING_JD_PROMISE',
    path: 'jdp/edit/:claimNumber'
};



// WEBPACK FOOTER //
// ./src/routes/claims/edit-jdp-claim-route.js